export interface ReelTogglerProps {
  onReelToggle?: (newValue: boolean) => void;
  isToggled?: boolean;
  isDisabled?: boolean;
  disabledTooltipText?: string;
}

export const REEL_TOGGLE_TOOLTIP_ID = 'reel-toggle-tooltip';
